var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Correct_User"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#37474f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.5 25c-.1 0-.2 0-.3 0-1.1-4.9-5.5-8.5-10.7-8.5s-9.6 3.6-10.7 8.5c-.1 0-.2 0-.3 0-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5h.3c1.1 4.9 5.5 8.5 10.7 8.5s9.6-3.6 10.7-8.5h.3c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 26.5h-.5v-6.5h3v4c0 1.4-1.1 2.5-2.5 2.5z",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.5 20h-17.5c0-4.1 3.4-7.5 7.5-7.5h5.2c2.2 0 4.3-.5 6.3-1.4l3.5-1.6v5.5c0 2.8-2.2 5-5 5z",
    fill: "#ffb300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 19.9v4.1c0 1.4 1.1 2.5 2.5 2.5h.5v-7.9c-.8.7-1.8 1.2-3 1.3z",
    fill: "#ffb300"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#37474f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 26,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 26,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m21 31c2 2 5.1 2 7.1 0",
    fill: "none",
    stroke: "#37474f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#37474f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.5 63.5v-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 55.5h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5 55.5h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 63.5v-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.5 63.5v-13.1c0-3-1.8-5.7-4.5-6.9l-9.5-4.1c-1.9 2.9-6.1 2.9-8 0l-9.5 4.2c-2.8 1.2-4.5 3.9-4.5 6.9v13.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.5 63.5v-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.5 38.5c-1.4 0-2.8-.3-4-.8v1.8c1.9 2.9 6.1 2.9 8 0v-1.8c-1.2.5-2.6.8-4 .8z"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#37474f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5 5.5h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.5 5.5h-1"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.6.5h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.6.5h1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m44.5 63.5h1.5c1.4 0 2.5-1.1 2.5-2.5v-25.5c0-1.4-1.1-2.5-2.5-2.5h-9",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 33h-9c-1.4 0-2.5 1.1-2.5 2.5v25.5c0 1.4 1.1 2.5 2.5 2.5h1.5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.5,
    cy: 15.5,
    fill: "#90caf9",
    rx: 10,
    ry: 10,
    transform: "matrix(.707 -.707 .707 .707 4.71 42.37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.2 15.5 3.5 3.5 7.1-7",
    fill: "none"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/user-check.61369abfa61045af6d2418ff568916cd.svg";
export { ForwardRef as ReactComponent };